import MessageBox from '@/components/common/messagebox/MessageBox.vue'

export default {
  name: 'ScheduledTaskList',
  data () {
    return {
      items: [],
      loading: true,
      isMounted: false,
      currentReq: null,
      paging: {
        limit: 10,
        total: 0,
        page: 1,
        pages: 1
      },
      clearingCache: false
    }
  },
  components: {
    MessageBox
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'callfunc', label: this.$t('scheduled-task.callfunc') },
        { key: 'cron', label: this.$t('scheduled-task.cron') },
        { key: 'date_period_id', label: this.$t('scheduled-task.date_period'), format: 'formatDatePeriod' },
        { key: 'status_id', label: this.$t('scheduled-task.status'), format: 'formatFromConfig', configKey: 'scheduled_task_statuses', configParam: 'name' },
        { key: 'lastRun', label: this.$t('scheduled-task.lastRun'), type: 'datetime' },
        { key: 'lastSuccess', label: this.$t('scheduled-task.lastSuccess'), type: 'datetime' },
        { key: 'error', label: this.$t('scheduled-task.error') },
        { key: 'info', label: this.$t('scheduled-task.info') },
        { key: 'forcerun', label: this.$t('scheduled-task.force-run'), type: 'actionlinks', emit: 'forceRunTask', bicon: 'play-fill', class: 'text-right', iconClass: 'btn-primary' },
        { key: 'actions', label: '', actions: [] }
      ];
      return headers;
    }
  },
  methods: {
    changePage (pageNr) {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.paging.page = pageNr;
      this.$forceUpdate();
      this.reloadTable();
    },
    forceRunTask (index, approved = 0) {
      const self = this;
      const task = this.items[index];
      if (approved) {
        this.items[index].forcerun = true;
        this.$refs.reportstable.$forceUpdate();
        this.ApiRequest.request('scheduled-tasks/force-run/' + task.id, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            if (typeof (response.data) === typeof ({})) {
              response.data = JSON.stringify(response.data);
            }
            self.ApiRequest.displaySuccessDialog(self, self.$t('scheduled-task.force-run-action.success', { info: response.data }));
          }
          self.items[index].forcerun = false;
          self.$refs.reportstable.$forceUpdate();
          self.reloadTable();
        });
      } else {
        this.$refs.taskRunMsgBox.show(index, this.$t('scheduled-task.force-run-action.title'), this.$t('scheduled-task.force-run-action.message', { callfunc: task.callfunc }))
      }
    },
    reloadTable () {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('scheduled-tasks/list', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging = response.paging;
        }
        self.loading = false;
      });
    },
    clearCache () {
      this.clearingCache = true;
      const self = this;
      this.ApiRequest.request('admin/clear-cache', this.ApiRequest.REQUEST_GET, [], function () {
        self.clearingCache = false;
      })
    }
  },
  mounted () {
    this.isMounted = true;
  }
}
